import { Facebook, Instagram, Mail, MessageCircle } from 'lucide-react';

const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61561000261625";
const INSTAGRAM_URL = "https://www.instagram.com/ananskitchenbristol/";
const GMAIL_ADDRESS = "ananskitchenbristol@gmail.com";
const WHATSAPP_URL = "https://wa.me/4407827893614?text=Hi%20ANAN's%20Kitchen!%20I'd%20like%20to%20know%20more%20about%20your%20meal%20plans.";

export default function SocialBar() {
  return (
    <div className="fixed right-3 sm:right-4 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-2 sm:gap-3" data-testid="social-bar">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:bg-[#1da851] transition-all hover:scale-110"
        data-testid="social-bar-whatsapp"
        title="Chat on WhatsApp"
      >
        <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
      </a>
      <a
        href={FACEBOOK_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-[#2C402E]/80 sm:bg-[#2C402E] text-white flex items-center justify-center shadow-lg hover:bg-[#E05D3A] transition-all hover:scale-110"
        data-testid="social-bar-facebook"
        title="Facebook"
      >
        <Facebook className="w-4 h-4 sm:w-5 sm:h-5" />
      </a>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-[#2C402E]/80 sm:bg-[#2C402E] text-white flex items-center justify-center shadow-lg hover:bg-[#E05D3A] transition-all hover:scale-110"
        data-testid="social-bar-instagram"
        title="Instagram"
      >
        <Instagram className="w-4 h-4 sm:w-5 sm:h-5" />
      </a>
      <a
        href={`mailto:${GMAIL_ADDRESS}`}
        className="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-[#2C402E]/80 sm:bg-[#2C402E] text-white flex items-center justify-center shadow-lg hover:bg-[#E05D3A] transition-all hover:scale-110"
        data-testid="social-bar-gmail"
        title="Email Us"
      >
        <Mail className="w-4 h-4 sm:w-5 sm:h-5" />
      </a>
    </div>
  );
}
